<script setup>
import { useKonamiIdLoginState } from "@/js/composables/useKonamiIdLoginState";

const { isKonamiIdLoginClickable, lock } = useKonamiIdLoginState();

defineOptions({
    name:'ButtonKonamiIdLogin'
})

defineProps({
    loginUrl:{type:String,required: true},
})

const click = () => {
    if (!isKonamiIdLoginClickable.value) return;
    lock();
};

</script>

<template>
    <a :href="loginUrl" @click="click">ログイン</a>
</template>

<style scoped>
</style>
